import axios from "axios";
const baseUrl = process.env.REACT_APP_API_URL;

export const autoLogin = async () => {
  const email = process.env.REACT_APP_AUTOLOGIN_EMAIL || "integer.admin@integer.com";
  const password = process.env.REACT_APP_AUTOLOGIN_PASSWORD || "123456.";

  const res = await axios.post(`${baseUrl}/auth/login`, { email, password });
  const token = res.data.auth.accessToken;

  localStorage.setItem("token", token);

  return token;
};
